import { SetMapPictureAutomobilePlatforms } from '@domain/platforms/picture-automobile-platform/mappers/picture-automobile-platform.mappers';
import { AutomobilePlatform } from '../domain/AutomobilePlatform.model';
import { AutomobilePlatformApiModel } from '../infrastructure/models/automobile-platform-api.model';
import { mapIncidencePlatformApiModelsToIncidencePlatforms } from '@domain/platforms/incidence-platform/mappers/incidence-platform.mappers';

export function SetMapAutomobilePlatform(
  automobilePlatform: AutomobilePlatformApiModel
): AutomobilePlatform {
  const {
    ID,
    CreatedAt,
    UpdatedAt,
    DeletedAt,
    vin,
    createdBy,
    updatedBy,
    ActivityPlatforms,
    PicturesAutomobile,
    IncidencesPlatform,
    ...rest
  } = automobilePlatform;

  return {
    id: ID,
    createdAt: CreatedAt,
    updatedAt: UpdatedAt,
    deletedAt: DeletedAt,
    vin: vin,
    createdBy: createdBy,
    updatedBy: updatedBy,
    activityPlatforms: ActivityPlatforms,
    picturesAutomobile: PicturesAutomobile
      ? SetMapPictureAutomobilePlatforms(PicturesAutomobile)
      : [],
    incidencesPlatform: IncidencesPlatform
      ? mapIncidencePlatformApiModelsToIncidencePlatforms(IncidencesPlatform)
      : [],
    ...rest,
  };
}
